import React, { useMemo, useState } from 'react'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp'
import type { Theme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core'
import { useLocation } from 'react-router-dom'
import Highlight from '@paintscout/ui/components/Highlight'
import Collapse from '@paintscout/ui/components/Collapse'
import IconButton from '@paintscout/ui/components/IconButton'
import Typography from '@paintscout/ui/components/Typography'
import HtmlContent from '@paintscout/ui/components/HtmlContent'
import type { ActivityTypeComponentProps } from '../Activity'
import ActivityFooter from '../ActivityFooter'
import ActivityOwner from '../ActivityOwner'
import ActivityTitle from '../ActivityTitle'
import QuoteActivitySubtitle from '../QuoteActivitySubtitle'
import ActivityDot from '../ActivityDot'
import ActivityContent from '../ActivityContent'
import { emailStyles } from '../emailStyles'

const useStyles = makeStyles((theme: Theme) => ({
  ...emailStyles(theme),
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    width: '100%',
    '& > div': {
      width: '100%'
    }
  },
  emailContainer: {
    width: '100%'
  },
  collapseText: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
    width: '100%',
    color: theme.palette.text.secondary,
    wordBreak: 'break-word'
  }
}))
export default function QuoteThankYouDeclinedActivity(props: ActivityTypeComponentProps) {
  const classes = useStyles()
  const { activity, showDocTypeDetails } = props
  const { pathname } = useLocation()
  const message = useMemo(
    () => (!pathname.includes('dashboard') && activity.details.events ? activity.details.events[0] : null),
    [pathname, activity.details.events]
  )
  const showContent = !!message
  const [collapsed, setCollapsed] = useState(showContent)

  const handleCollapseChange = (e, isOpen: boolean) => {
    e.preventDefault()
    e.stopPropagation()
    setCollapsed(isOpen)
  }

  return (
    <>
      <ActivityTitle>
        <ActivityDot activity={activity} />
        <Highlight>Thank You Email</Highlight> (declined) was <Highlight>sent</Highlight>
        {showDocTypeDetails && <ActivityOwner activity={activity} />}
      </ActivityTitle>
      {showContent && (
        <ActivityContent className={classes.content}>
          <Collapse show={collapsed}>
            <Typography
              variant="body2"
              color="textSecondary"
              className={classes.collapseText}
              style={{ height: 16 }}
              onClick={(e) => handleCollapseChange(e, false)}
            >
              View message
              <IconButton size="small">
                <KeyboardArrowDownIcon />
              </IconButton>
            </Typography>
          </Collapse>
          <Collapse show={!collapsed}>
            <div className={classes.emailContainer}>
              <HtmlContent
                content={message ?? ''}
                classes={{ root: classes.emailContent, paragraphs: classes.emailParagraphs }}
              />
            </div>
            <Typography variant="body2" className={classes.collapseText} onClick={(e) => handleCollapseChange(e, true)}>
              Hide message
              <IconButton size="small">
                <KeyboardArrowUpIcon />
              </IconButton>
            </Typography>
          </Collapse>
        </ActivityContent>
      )}
      <QuoteActivitySubtitle activity={activity} showDocTypeDetails={showDocTypeDetails} />
      <ActivityFooter timestamp={activity.details.timestamp} />
    </>
  )
}
